import axios from "axios";
import { Config } from "../Config";
import { userAccessToken } from "../helpers";
export const getInvoicesData = async (filter, account_id, location_id) => {
  try {
    const { page, per_page, search_term, order_by } = filter;
    let searchParam = search_term ? `&search_term=${search_term}` : "";
    let orderBy = order_by ? `&order_by=${JSON.stringify(order_by)}` : "";

    const response = await axios.get(
      `${Config.paymentServerUrl}/get-invoices?account_id=${account_id}&location_id=${location_id}&page=${page}&per_page=${per_page}${searchParam}${orderBy}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );

    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const subscriptionPackage = async (subscribeData) => {
  try {
    const response = await axios.post(`${Config.paymentServerUrl}/create-checkout-subscription`,subscribeData,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const unsubscriptionPackage = async (formData) => {
  try {
    const response = await axios.put(`${Config.paymentServerUrl}/cancel-subscription`, formData, {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    });
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const getSubscriptionData = async (getProductData) => {
  try {
    const response = await axios.post(`${Config.paymentServerUrl}/get-subscription`, getProductData,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const fetchSingleInvoice = async (account_id, location_id, id) => {
  try {
    const response = await axios.get(
      `${Config.paymentServerUrl}/invoices/${id}?account_id=${account_id}&location_id=${location_id}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );

    return response;
  } catch (error) {}
};

export const getPaymentStatus = async (statusData) => {
  try {
    const response = await axios.post(`${Config.paymentServerUrl}/check-session`,statusData,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const createBillingInvoice = async (formData) => {
  try {
    const response = await axios.post(`${Config.paymentServerUrl}/create-billing-invoice`, formData, {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    });
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const updateInvoice = async (formData) => {

  try {
    const response = await axios.put(`${Config.paymentServerUrl}/invoices/update`, formData, {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    });
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const createPaymentLink = async (subscribeData) => {
  try {
    const response = await axios.post(`${Config.paymentServerUrl}/generate-payment-link`,subscribeData,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const chackBillPaymentStatus = async (props) => {
  const { shortener_slug } = props;
  try {
    const response = await axios.get(`${Config.paymentServerUrl}/shortener-slug-validation/${shortener_slug}`);
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const oneTimeCheckoutPackage = async (subscribeData) => {
  try {
    const response = await axios.post(`${Config.paymentServerUrl}/create-one-time-checkout`,subscribeData,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const getAvailableProducts = async () => {
  try {
    const response = await axios.get(`${Config.paymentServerUrl}/active-products?product_type=docpro_subscription&price_nickname=MONTHLY&return_values=product_id&return_values=price_id`);
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const fetchCodingBillingData = async (account_id, location_id) => {
  try {
    const response = await axios.get(
      `${Config.paymentServerUrl}/get-cc-biling-invoice-settings?account_id=${account_id}&location_id=${location_id}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );

    return response;
  } catch (error) {}
};

export const deleteInvoice = (id, account_id, practice_id) => {
  try {
    const response = axios.delete(`${Config.paymentServerUrl}/delete-invoice/${id}?account_id=${account_id}&location_id=${practice_id}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;

  } catch (error) {
    return error?.response?.data;
  }
};

export const checkoutInvoicePayment = async (payInvoiceData) => {
  try {
    const response = await axios.post(`${Config.paymentServerUrl}/checkout-invoice-payment`,payInvoiceData,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const getActiveProductsData = async (props) => {
  const { location_id, account_id } = props;
  try {
    const response = axios.get(`${Config.paymentServerUrl}/active-products?account_id=${account_id}&location_id=${location_id}`, {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    });
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const acceptInvoice = async (payInvoiceData) => {
  try {
    const response = await axios.post(`${Config.paymentServerUrl}/accept-invoice-payment`,payInvoiceData,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};
